import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CLIENT_API = `${BACKEND_URL}/api`;

export const clientHttp = axios.create({ baseURL: CLIENT_API, withCredentials: true });

// Auth token lives in a secure httpOnly cookie (sent automatically via credentials).
clientHttp.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("bc_client_session")) {
      localStorage.removeItem("bc_client_session");
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/dashboard")) {
        window.location.assign("/dashboard");
      }
    }
    return Promise.reject(error);
  }
);

export async function cget(path, params) {
  const { data } = await clientHttp.get(path, { params });
  return data;
}
export async function cpost(path, body) {
  const { data } = await clientHttp.post(path, body);
  return data;
}

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
}
